import { AnyAction } from '@reduxjs/toolkit'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import React, { Dispatch, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import useSound from 'use-sound'
import Loading from '../../../components/Loading'
import {
  addTeamNameRequest,
  checkIfTeamNameIsAddedRequest,
} from '../../../redux/actions/gameActions'
import { showErrorNotification } from '../../../redux/actions/notificationActions'
import { getGameSelector } from '../../../redux/selectors/gameSelectors'
import { GameState } from '../../../redux/types/game'
import clickSoundEffect from '../../../assets/audio/click2.wav'
import { ArrowRight } from 'iconsax-react'
import { useTranslation } from 'react-i18next'
import TeamIllustration from '../components/TeamIllustration'
import * as Sentry from '@sentry/react'

const AddTeamName = () => {
  const [teamNameValue, setTeamNameValue] = useState('')
  const {
    loading: gameLoading,
    data: { isTeamNameAdded, volumeGlobal, branding },
  }: GameState = useSelector(getGameSelector)
  const dispatch: Dispatch<AnyAction> = useDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const [clickSound] = useSound(clickSoundEffect, {
    volume: volumeGlobal,
  })

  useEffect(() => {
    dispatch(checkIfTeamNameIsAddedRequest())

    // check if team name is entered
  }, [])

  useEffect(() => {
    if (isTeamNameAdded) {
      navigate('/welcome')
    }
  }, [isTeamNameAdded])

  const handleSubmitTeamName = () => {
    clickSound()
    if (teamNameValue !== '') {
      dispatch(addTeamNameRequest({ teamName: teamNameValue, navigate }))
    } else {
      dispatch(showErrorNotification(t('TeamNameCannotBeEmpty')))
    }
  }

  Sentry.setContext('Variables', {
    teamNameValue,
  })

  if (gameLoading.isLoadingTeamNameExists) {
    return <Loading />
  }

  return (
    <div
      style={{ width: '100%', height: '100vh' }}
      className="flex flex-column align-items-center"
    >
      <div
        style={{
          width: '100%',
          height: '20vh',
          background: branding?.steps.backgroundColor,
        }}
        className="flex justify-content-center align-items-center"
      >
        <h4
          className="zoominleft animation-duration-1000"
          style={{
            color: branding?.steps.textColor,
            marginTop: '-15%',
            zIndex: 1111,
          }}
        >
          {t('Step')} 2/3
        </h4>
      </div>
      <div
        style={{
          // width: '90%',
          // borderTopRightRadius: '50%',
          // borderTopLeftRadius: '50%',
          borderRadius: '27px',
          marginTop: '-20%',
          background: ' #fff',
          height: '90vh',
          // padding: '4vw',
          width: '100%',
        }}
        className="flex justify-content-center"
      >
        {/* <div className="w-full flex align-items-center justify-content-center"> */}
        <div
          style={{ width: '90%', margin: 'auto' }}
          className="flex flex-column align-items-stretch text-center"
        >
          {branding && (
            <div
              style={{
                // clipPath: 'polygon(8% 0, 100% 0%, 100% 100%, 0 100%)',
                width: 'inherit',
                height: '25vh',
                marginTop: '30px !important',
                // padding: '3vh',import { useEffect } from 'react';
              }}
            >
              <TeamIllustration
                clothesColor={branding?.illustrations.clothesColor}
                skinColor={branding?.illustrations.skinColor}
                redPuzzleColor={branding?.illustrations.redPuzzleColor}
                lightPuzzleColor={branding?.illustrations.lightPuzzleColor}
                jeansColor={branding?.illustrations.jeansColor}
              />
            </div>
          )}
          {/* <img
            src="/assets/layout/images/team-edited.svg"
            alt="Game"
            className="mx-auto fadeinleft animation-duration-1000"
            // height={200}
            // className="mb-3"
            style={{
              // clipPath: 'polygon(8% 0, 100% 0%, 100% 100%, 0 100%)',
              width: 'inherit',
              height: '25vh',
              marginTop: '30px !important',
              // padding: '3vh',
            }} */}
          {/* /> */}
          {/* <div className="text-900 text-3xl font-medium mb-3">Welcome</div> */}
          {/* <span className="text-600 font-medium line-height-3">
              Enter the team name.
            </span> */}
          {/* </div> */}

          <div>
            {/* <label htmlFor="email" className="block text-900 font-medium mb-2">
              Team Name
            </label> */}
            {/* <div> */}
            <h3
              style={{ color: '#333' }}
              className="my-5  fadeinup animation-duration-1000"
            >
              {t('TeamName')}
            </h3>
            <p className="fadeinup animation-duration-1000">
              {t('EnterTeamName')}
            </p>
            {/* </div> */}
            <InputText
              id="team-name"
              type="text"
              value={teamNameValue}
              onChange={(e) => setTeamNameValue(e.target.value)}
              placeholder={t('EnterTeamNameInput')}
              className="w-full  zoominleft animation-duration-1000 pl-4"
            />
          </div>
          {/* <Button
            onClick={handleSubmitTeamName}
            label="Submit"
            loading={gameLoading.isSavingTeamName}
            icon={<Game color="#fff" variant="Broken" />}
            className="w-full"
          /> */}
          <Button
            label={t('Next')}
            onClick={handleSubmitTeamName}
            // className="p-button-rounded mt-4 py-3  zoominleft animation-duration-1000"
            icon={
              <>
                <div
                  className="p-2 p-button-icon p-button-icon-right rounded-icon-style"
                  style={{
                    backgroundColor: branding?.buttonPrimary.textColor,
                  }}
                >
                  {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
                </div>
                <ArrowRight
                  color={branding?.buttonPrimary.backgroundColor}
                  // variant="Bold"
                  className="icon-center"
                  // className="p-button-icon p-c p-button-icon-right"
                />
              </>
            }
            className="p-button-rounded mt-4 py-3 zoominleft animation-duration-1000 uppercase"
            style={{
              backgroundColor: branding?.buttonPrimary.backgroundColor,
              color: branding?.buttonPrimary.textColor,
            }}
            loading={gameLoading.isSavingTeamName}
          />
        </div>
      </div>
    </div>
  )
}

export default AddTeamName
